/*
 * @Date: 2026-03-31 10:00:00
 * @Description: SSE弹幕相关API - 替代WebSocket实现
 */
import { request } from "@/request/request";
import { parameterChange } from "@/utils/utils";

export default {
  // 获取SSE连接ID
  getSseConnectId(data) {
    return request({
      url: "/sse/getConnectId",
      method: "get",
      data,
    });
  },
  // 切换SSE连接的目录
  sseChange(data) {
    return request({
      url: "/sse/change?" + parameterChange(data),
      method: "get",
      data,
    });
  },
  // 发送弹幕（SSE）
  sseSendBarrage(data) {
    return request({
      url: "/sse/sendBarrage?type=" + data.type + "&connectId=" + data.connectId,
      method: "post",
      data,
    });
  },
  // 关闭SSE连接
  sseClose(data) {
    return request({
      url: "/sse/close?" + parameterChange(data),
      method: "get",
      data,
    });
  },
};
